export enum RecipientBankAccountQueryKeys {
  GET_OWN_LIST = 'RECIPIENT_BANK_ACCOUNT_GET_OWN_LIST',
  GET_BANKS = 'RECIPIENT_BANK_ACCOUNT_GET_BANKS',
  LOOKUP_ACCOUNT = 'RECIPIENT_BANK_ACCOUNT_LOOKUP_ACCOUNT',
}
